import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { apiService } from "service/ApiService";
import StoreContext from "contexts/StoreContext";
import DateRangeContext from "contexts/DateRangeContext";
import { getModeNameByid } from "utils/AppUtils";
import HourSalesCard from "components/Cards/HourSalesCard";
import { ClipLoader } from "react-spinners";

import { useTranslation } from "react-i18next";

function HoursStatsPage() {
  const {
    t,
  } = useTranslation();

  const { storeId, setStoreId } = useContext(StoreContext);
  const { dateRange, setDateRange } = useContext(DateRangeContext);
  const [data, setData] = useState({});
  const [showLoader, setShowLoader] = useState(true);

  const refreshData = () => {
    setShowLoader(true);
    apiService
      .post(`api/v1/stores/${storeId}/hour-sales`, {
        fromDate: dateRange[0],
        toDate: dateRange[1],
      })
      .then((resp) => {
        formatData(resp);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setShowLoader(false);
      });
  };

  const formatData = (response) => {
    let data = {
      total: {
        name: t("tables.headers.total"),
        total: 0,
        orders: 0,
        hours: [],
      },
    };
    for (const res of response) {
      if (!data[res.mode_id]) {
        data[res.mode_id] = {
          total: 0,
          orders: 0,
          name: getModeNameByid(res.mode_id),
          hours: [],
        };
      }
      data[res.mode_id].hours.push({
        hour: res.hour,
        total: res.total,
        orders: Number(res.orders),
      });
      data[res.mode_id].total += res.total;
      data[res.mode_id].orders += Number(res.orders);

      const hourId = data.total.hours.findIndex((el) => el.hour === res.hour);
      if (hourId === -1) {
        data.total.hours.push({
          hour: res.hour,
          total: res.total,
          orders: Number(res.orders),
        });
      } else {
        data.total.hours[hourId].total += res.total;
        data.total.hours[hourId].orders += Number(res.orders);
      }
      data.total.total += res.total;
      data.total.orders += Number(res.orders);
    }

    for (const key of Object.keys(data)) {
      for (let i = 0; i < data[key].hours.length; i++) {
        data[key].hours[i].percentage = (data[key].hours[i].total / data[key].total) * 100;
      }
    }

    console.log(data);
    setData(data);
  };

  useEffect(() => {
    if (!storeId || !dateRange) return;
    refreshData();
  }, [storeId, dateRange]);

  return (
    <>
      <Container fluid>
        {showLoader ? (
          <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
            <ClipLoader size={50} color={"#ff6fbc"} />
          </div>
        ) : (
          Object.keys(data).map((key) => (
            <Row key={key}>
              <Col key={`col-${key}`} xs={12} md={12}>
                <HourSalesCard data={data[key]} />
              </Col>
            </Row>
          ))
        )}
      </Container>
    </>
  );
}

export default HoursStatsPage;
